<template>
  <section
    class="component-d6b883a3"
    resmed-component-name="custom_interactive_poc_home"
  >
    <div class="component">
      <div class="embed-responsive embed-responsive-4by3 d-md-none">
        <!-- // -->
      </div>

      <!-- md lg xl -->
      <div class="container px-xs-sm-2 d-none d-md-block">
        <div class="row justify-content-center">
          <div class="col col-lg-10 col-xl-9 text-center">
            <eyebrow-icon
              v-if="acf.eyebrowicon"
              v-bind:eyebrowicon="acf.eyebrowicon"
              v-bind:align="'center'"
            ></eyebrow-icon>
            <div class="title">
              <h5>{{ acf.name }}</h5>
            </div>
            <h1 v-html="acf.headline"></h1>
            <p v-html="acf.content"></p>

            <div class="in-view">
              <div class="animation" v-if="active">
                <transition
                  name="slide"
                  v-on:after-enter="afterEnter"
                  mode="out-in"
                  appear
                >
                  <div class="steps" v-bind:key="step.value">
                    <div class="step-offset">
                      <h4
                        v-html="
                          `${step.active.step}<br />${step.active.headline}`
                        "
                      ></h4>
                      <p v-html="step.active.description"></p>
                    </div>
                  </div>
                </transition>
                <div class="wrapper">
                  <animation-interactive
                    v-bind:step.sync="step.value"
                    v-bind:animation="JSON.parse(acf.animation)"
                  ></animation-interactive>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- xs sm -->
      <div class="container px-xs-sm-2 d-block d-md-none">
        <div class="content pt-6 pb-4">
          <eyebrow-icon
            v-if="acf.eyebrowicon"
            v-bind:eyebrowicon="acf.eyebrowicon"
            v-bind:align="'center'"
          ></eyebrow-icon>
          <div class="title">
            <h5>{{ acf.name }}</h5>
          </div>
          <h1 v-html="acf.headline"></h1>
          <p v-html="acf.content"></p>

          <div class="steps">
            <div class="step my-5" v-for="item in steps">
              <h4>
                <span>{{ item.step }}</span>
              </h4>
              <h4 v-html="item.headline"></h4>
              <p v-html="item.description"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import inView from "in-view"; // https://github.com/camwiegert/in-view
import animationInteractive from "../shared-support/animation-interactive-po-home";

export default {
  name: "component-d6b883a3", // custom_interactive_poc_home
  props: ["acf"],
  components: {
    animationInteractive,
  },
  data() {
    return {
      active: false,
      step: {
        value: 0,
        active: {},
      },
      steps: [],
      interval: undefined,
    };
  },
  methods: {
    afterEnter() {
      bus.$emit("tooltip:bind-event");
    },
    play() {
      this.step.value = 1;
      clearInterval(this.interval);

      // autoplay
      this.interval = setInterval(() => {
        if (this.step.value < 4) {
          this.step.value += 1;
        } else {
          this.step.value = 1; // loop
          clearInterval(this.interval);
        }
      }, 4700);

      this.$on("interval:clear", (val) => {
        val && clearInterval(this.interval);
      });
    },
  },
  watch: {
    "step.value"(val) {
      this.step.active = this.steps[val];
    },
    interval(val) {
      if (!val) {
        clearInterval(this.interval);
      }
    },
  },
  mounted() {
    inView.threshold(0.2);

    inView(".component-d6b883a3 .in-view")
      .on("enter", (el) => {
        this.active = true;
        this.play();
      })
      .on("exit", (el) => {
        this.active = false;
        this.step.value = 0;
      });
  },
  created() {
    this.steps = this.acf.steps;
    this.steps.unshift(0); // compensate for index zero 0
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.slide-enter {
  opacity: 0;
  transform: translateY(60px);
}

.slide-leave-to {
  opacity: 0;
  transform: translateY(-60px);
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s;
}

.component-d6b883a3 {
  //
}

.in-view {
  height: 620px;
}

.component {
  background-color: $cc-resmed-grey-85;
  padding: 0;

  @media (max-width: 767px) {
    & > :first-child {
      background-image: url(#{$assets}/images/mobi-poc-bg-img@2x.jpg);
      background-repeat: no-repeat;
      background-position: top center;
      background-size: cover;
    }
  }

  @media (min-width: 768px) {
    padding: 5rem 0;

    background-image: url(#{$assets}/images/mobi-poc-bg-img@2x.jpg);
    background-repeat: no-repeat;
    background-position: top center;
    background-size: cover;
  }

  > * {
    color: $cc-resmed-white;

    @media (max-width: 767px) {
      text-align: center;
    }
  }

  svg {
    transform: translateY(-1.75rem);
  }

  .title {
    margin-bottom: 0.5rem;
    @extend %body-normal-bold;

    h5 {
      position: relative;
      margin-bottom: 0.25rem;

      @extend %eyebrow-center;
      &:before {
        background-color: $cc-resmed-white;
      }

      @media (min-width: 768px) {
        margin-bottom: 0.75rem;
      }

      @media (min-width: 992px) {
        min-height: 0;
      }
    }
  }

  h1 {
    position: relative;
    margin: 0 0 1rem 0;
  }

  .content {
    .steps {
      .step:first-child {
        // index 0
        display: none !important;
      }
    }

    .step {
      h4:first-child {
        margin: 0 auto 1rem auto;
        background-color: $cc-resmed-action-red;
        border-radius: 50%;
        width: 4rem;
        height: 4rem;
        line-height: 1;

        display: flex;
        align-items: center;
        justify-content: center;

        span {
          display: block;
        }
      }
    }
  }

  .cta {
    > a {
      margin: 0 0.5rem;
    }
  }
}

.animation {
  height: 620px;
  position: relative;
  padding: 4rem 0;

  display: flex;
  align-items: center;
  justify-content: center;

  .wrapper {
    position: absolute;
    transform: translateX(-0.625rem);

    width: 650px; // safari
    height: 656px; // safari
    top: 0;
    left: 50%;
    margin-left: -325px;
  }

  .step-offset {
    transform: translateY(-1rem);
  }

  .steps {
    max-width: 320px;
    z-index: 99;

    h4 {
      line-height: 1.5;
    }

    p {
      // @extend %body-small;
      line-height: 1.8;
    }
  }
}
</style>